import * as React from "react";
import { useState, useContext, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import {ICGFormControl} from '~common/components/icg-form-control';
import {
  FormControlLabel,
  Checkbox,
  Radio,
  Grid,
} from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    checkboxField: {
      width: "100%",
    },
  })
);

interface CheckboxProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
}


export const CheckboxField: React.FC<CheckboxProps> = ({
  fieldDefinition,
  policyMessages,
  contextType,
  onAccessRootData,
  path,
  onValidate,
  readOnlyOverride
}) => {
  const classes = useStyles();    

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setFieldVal will pass the value up to the parent component that houses the context.

  const [fieldVal, setFieldVal] = useContext(ValueContext);

  // const [localVal, setLocalVal] = useState(fieldVal || null);
  const [localMessageText, setLocalMessageText] = useState("");
  const [localMessageClass, setLocalMessageClass] = useState("");


  const isChecked = (target) => {
    if (fieldVal) {
      var valueStrings = fieldVal.split('|')

      for (var vString of valueStrings) {
          if (target == vString) {
            return true
          }
      }
    }
    return false
  }

  const onChange = (event) => {
    
    var valueStrings = []
    if (fieldVal) {
      valueStrings = fieldVal.split('|')
    }

    if (isChecked(event.target.value)) { 
      valueStrings.forEach(function (string, i) {
        if (string == event.target.value) {
          valueStrings.splice(i, 1)
        }
      })
    } else {
      valueStrings.push(event.target.value)
    }

    setFieldVal(valueStrings.join('|'));

  }


  var options = fieldDefinition.options;

  return (

    <ICGFormControl fieldDefinition={fieldDefinition} readOnlyOverride={readOnlyOverride} policyMessages={policyMessages} fieldControlMessage={localMessageText} fieldControlClass={localMessageClass}> 
      <Grid container name={fieldDefinition.key}>
        {options && options.map((o: any) => {
          var cbAttr: any;
          if (fieldDefinition.checkboxGridAttributes) {
            cbAttr = fieldDefinition.checkboxGridAttributes;
          } else {
            cbAttr = {};
          }
          return (
            <Grid
              item
              xs={cbAttr.xs || "auto"}
              sm={cbAttr.sm || "auto"}
              md={cbAttr.md || "auto"}
              lg={cbAttr.lg || "auto"}
              xl={cbAttr.xl || "auto"}
              key={fieldDefinition.key + o.value + "grid"}
            >
              <FormControlLabel
                key={fieldDefinition.key + o.value}
                // style={{display:'table'}}
                control={(
                    <Checkbox
                      inputProps={{
                        name: o.value,
                        "data-field-key": fieldDefinition.key,
                        "data-field-path": path,
                        "data-field-type": fieldDefinition.type,
                      }}
                      checked={isChecked(o.value)}
                      onChange={onChange}
                      value={o.value}
                      key={fieldDefinition.key + o.value + "checkbox"}
                      color="primary"
                      disabled={
                        fieldDefinition.mode == "Read Only" ||
                        fieldDefinition.mode == "Display" ||
                        readOnlyOverride
                      }
                    />
                  )
                }
                label={o.label}
              />
            </Grid>
          );
        })}
      </Grid>
    </ICGFormControl> 
  )
};

export default CheckboxField;
